import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    minHeight: "100vh",
    background: "#F2F1F1",
    overflowX: "hidden",
  },
  content: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    overflowX: "hidden",
  },
  tableRoot: {
    display: "flex",
    flexDirection: "column",
    width: "78%",
    marginTop: "31vh",
    marginLeft: "19%",
    overflowX: "hidden",
    maxHeight: "57vh !important",
  },
  contentHome: {
    display: "flex",
    flexDirection: "row",
    width: "85%",
    justifyContent: "left",
    alignItems: "center",
    flexWrap: "wrap",
    marginTop: "31vh",
    margin: "auto",
    overflowX: "hidden",
    maxHeight: "57vh !important",
    height: "57vh",
    backgroundColor: "#fff",
    borderRadius: "5px",
  },
  paper: {
    padding: "0px 0px",
    display: "flex",
    alignItems: "center",
    width: "80%",
    backgroundColor: "#FFF",
    marginBottom: "3%",
    color: "#949494",
  },
  input: {
    marginLeft: theme.spacing(1),
    flex: 1,
    color: "#949494",
    paddingTop: "4px",
    paddingBottom: "4px",
    paddingLeft: "1%",
    fontSize: "16px",
    opacity: "100%",
  },
  iconButton: {
    color: "#949494",
  },
  button: {
    width: "28%",
    backgroundColor: "#026894",
    color: "#FFF",
    paddingTop: "5px",
    paddingBottom: "5px",
    paddingRight: "2px",
    paddingLeft: "2px",
    boxShadow: "none",
    border: "none",
    textTransform: "capitalize",
    fontSize: "12px",
    marginLeft: "25px",
    "&:hover": {
      backgroundColor: "#026894",
    },
  },
  buttonVisualize: {
    width: "100px",
    backgroundColor: "#4AAF05",
    color: "#FFF",
    paddingTop: "5px",
    paddingBottom: "5px",
    boxShadow: "none",
    border: "none",
    textTransform: "capitalize",
    fontSize: "12px",
    marginRight: "2%",
    "&:hover": {
      background: "#347706",
    },
  },
  buttonEdit: {
    width: "100px",
    backgroundColor: "#FB8832",
    color: "#FFF",
    paddingTop: "5px",
    paddingBottom: "5px",
    boxShadow: "none",
    border: "none",
    textTransform: "capitalize",
    fontSize: "12px",
    marginRight: "2%",
    "&:hover": {
      background: "#b76428",
    },
  },
  buttonDelete: {
    width: "79px",
    backgroundColor: "#FF5756",
    color: "#FFF",
    paddingTop: "5px",
    paddingBottom: "5px",
    boxShadow: "none",
    border: "none",
    textTransform: "capitalize",
    fontSize: "12px",
    marginRight: "2%",
    "&:hover": {
      background: "#a53030",
    },
  },
  link: {
    color: "#FFF",
    textTransform: "capitalize",
    fontSize: "12px",
    textDecoration: "none",
  },
  smallLink: {
    color: "#FFF",
    textTransform: "capitalize",
    fontSize: "12px",
    textDecoration: "none",
  },
  divSearch: {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },
  table: {
    width: "100%",
  },
  selectStatus: {
    width: "100%",
    border: "1px solid #ccc",
    padding: "7px 6px",
  },
  cardLink: {
    alignItems: "center",
    background: "#232d64",
    borderRadius: "8px",
    justifyContent: "center",
    flexFlow: "row wrap",
    height: 100,
    textAlign: "center",
    textDecoration: "none",
    margin: "16px 32px",
    padding: "0px 10px",
    width: 250,
  },
  cardLinkText: {
    color: "#fff",
    display: "flex",
    height: "100%",
    alignItems: "center",
    flexFlow: "column wrap",
    justifyContent: "center",
  },
}));

export default useStyles;
